import { buildStoryblokUrl } from "~/utils/storyblok/buildStoryblokUrl";

interface StoryblokApiLike {
	get(
		url: string,
		params?: Record<string, unknown>
	): Promise<{ data: { story: unknown } }>;
}

interface FetchOptions {
	version: string;
	language: string;
	resolve_links?: "url" | "story";
}

interface FolderConfig {
	storyblokFolder?: string | null;
	storyblokFallbackFolder?: string | null;
}

export async function fetchStoryblokContentByFolder(
	api: StoryblokApiLike,
	path: string,
	options: FetchOptions,
	folderConfig: FolderConfig
): Promise<{ data: { story: unknown } }> {
	const { storyblokFolder, storyblokFallbackFolder } = folderConfig;
	const foldersToTry: (string | null)[] = [];
	const addFolderAttempt = (folder?: string | null) => {
		if (!folder || foldersToTry.includes(folder)) {
			return;
		}
		foldersToTry.push(folder);
	};

	addFolderAttempt(storyblokFolder);
	addFolderAttempt(storyblokFallbackFolder);
	foldersToTry.push(null);

	let lastError: unknown;
	for (const folder of foldersToTry) {
		try {
			const url = buildStoryblokUrl(path, folder);
			const { data } = await api.get(url, options);
			if (data?.story) return { data };
		} catch (e) {
			lastError = e;
		}
	}
	throw lastError ?? new Error("Failed to fetch Storyblok content");
}
